import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
  Stack,
  Chip,
} from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';

const baseUrl = process.env.REACT_APP_API_PATH;

const ConfirmInterviews = () => {
  const [data, setData] = useState([]);
  const { userResult } = useSelector((state) => state.Auth);
  const [loading, setLoading] = useState(false);

  const vendorId = userResult?.vendorid;

  useEffect(() => {
    fetchConfirmedInterviews();
  }, [vendorId]);

  const fetchConfirmedInterviews = async () => {
    if (!vendorId) return;

    try {
      setLoading(true);
      const response = await axios.get(
        `${baseUrl}/ebench/vendor/interview/accepted`,
        { params: { vendorId } }
      );
      setData(response.data?.data || []);
    } catch (error) {
      console.error(
        'Failed to fetch confirmed interviews',
        error.response?.data || error.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700} mb={2}>
        Confirmed Interviews
      </Typography>

      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Job Id</strong></TableCell>
                  <TableCell><strong>Candidate</strong></TableCell>
                  <TableCell><strong>Job Title</strong></TableCell>
                  <TableCell><strong>Interview Date & Time</strong></TableCell>
                  <TableCell><strong>Interview Mode</strong></TableCell>
                  <TableCell><strong>Status</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                )}

                {!loading && data.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography color="text.secondary">
                        No confirmed interviews found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}

                {!loading &&
                  data.map((row) => (
                    <TableRow key={row.interviewId}>
                      <TableCell>{row.jobId}</TableCell>
                      <TableCell>{row.candidateName}</TableCell>
                      <TableCell>{row.jobTitle}</TableCell>
                      <TableCell>
                        {new Date(row.interviewDate).toLocaleString('en-US', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })}
                      </TableCell>
                      <TableCell>{row.interviewMode}</TableCell>
                      <TableCell>
                        <Chip
                          label="CONFIRMED"
                          size="small"
                          color="success"
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ConfirmInterviews;
